import { updateKeyInStore } from 'App';
import { GeneralInfoStateValues, updateKey } from '../slice';

export const uploadFields: IBaseField<keyof GeneralInfoStateValues> | {}[] = [
  {
    name: 'pleaseUploadACopyOfYourProofOfFranchiseTaxPayment',
    label: 'Please upload a copy of your proof of Franchise Tax payment.',
    type: 'upload',
    effect: updateKeyInStore(updateKey),
    predicate: (v: string) => v === 'yes',
    dependentOn:
      'taxQuestionnaire.businessInfo.generalInfo.values.didYouMakeYourYearCaliforniaFranchiseTaxPayment',
  },
  {
    name: 'pleaseUploadACopyOfYourPreviousYearsTaxReturn',
    label: "Please upload a copy of your previous year's tax return.",
    type: 'upload',
    effect: updateKeyInStore(updateKey),
    predicate: (v: string) => v === 'no',
    dependentOn:
      'taxQuestionnaire.businessInfo.generalInfo.values.isThisYourFirstYearFilingATaxReturnForBusiness',
  },
];
